import type { DocEntityType } from "building-types/doc/docEntityTypes";
import type { DocEntityTableFields } from "../docTableFieldNames";

export const docEntityTableFieldsToEntityType: {
  [type in keyof DocEntityTableFields]: DocEntityType | undefined;
} = {
  underlays: "UNDERLAY",
  roofUnderlays: "UNDERLAY",
  assets: "ASSET",
  blocks: "BLOCK",
  rooms: "ROOM",
  roomLayouts: "ROOM_LAYOUT",
  roomLayoutInstances: "ROOM_LAYOUT_INSTANCE",
  stairSystems: "STAIR_SYSTEM",
  stairBlocks: "STAIR_BLOCK",
  stairCatalog: "STAIR_SETTING",
  railings: "RAILING",
  railingPosts: "RAILING_POST",
  freeformWalls: "FREEFORM_WALL",
  roofSystems: "ROOF_SYSTEM",
  selectors: "SELECTOR",
  viewOverrides: "VIEW_OVERRIDE",
  viewSelectors: "VIEW_SELECTOR",
  roofs: "ROOF",
  roofVolumes: "ROOF_VOLUME",
  foundationSystems: "FOUNDATION_SYSTEM",
  foundations: "FOUNDATION",
  elevations: "ELEVATION",
  facades: "FACADE",
  facadeSpanStrata: "FACADE_SPAN_STRATUM",
  facadeSweepStrata: "FACADE_SWEEP_STRATUM",
  referenceGeom: "REFERENCE_GEOM",
  sheets: "SHEET",
  drawingRefs: "DRAWING_REF",
  palettes: "PALETTE",
  annotation: "ANNOTATION",
  edgeBehaviors: "EDGE_BEHAVIOR",
  casework: "CASEWORK",
  ceilings: "CEILING",
  propInstances: "PROP_INSTANCE",
  propAttributes: "PROP",
  profiles: "PROFILE",
  railingCatalog: "RAILING_SETTING",
  levels: "LEVEL",
  compositeLevels: "COMPOSITE_LEVEL",
  roofOpenings: "ROOF_OPENING",
  groups: "GROUP",
  components: "COMPONENT",
  componentInstances: "COMPONENT_INSTANCE",
  settingsSets: "SETTINGS_SET",
  entitySettings: "ENTITY_SETTINGS",
  settings: "SETTINGS",
  optionTemplates: "OPTION_TEMPLATE",
  dormers: "DORMER",
  skylights: "SKYLIGHT",
  modifiers: "MODIFIER",
  edgeModifiers: "EDGE_MODIFIER",
  measurements: "MEASUREMENT",
  openings: "OPENING",
  floors: "FLOOR",
  floorFinishes: "FLOOR_FINISH",
  sites: "SITE",
  siteShapes: "SITE_SHAPE",
  optionEffects: "OPTION_EFFECT",
  optionRules: "OPTION_RULE",
  optionSetOverrides: "OPTION_SET_OVERRIDES",
  optionSets: "OPTION_SET",
  instanceOptionSets: "INSTANCE_OPTION_SET",
  optionLocks: "OPTION_LOCK",
  columns: "COLUMN",
  wallPlaneAssemblies: "WALL_PLANE_ASSEMBLY",
  view3Ds: "VIEW_3D",
  planViews: "PLAN_VIEW",
  elevationViews: "ELEVATION_VIEW",
  electricalDevices: "ELECTRICAL_DEVICE",
  electricalLayouts: "ELECTRICAL_LAYOUT",
  planSetTemplates: "PLAN_SET_TEMPLATE",
  planSetTemplateConfigs: "PLAN_SET_TEMPLATE_CONFIG",
  contentTemplates: "CONTENT_TEMPLATE",
  contentTemplateInstances: "CONTENT_TEMPLATE_INSTANCE",
  contentReplicators: "CONTENT_REPLICATOR",
  localParameters: "LOCAL_PARAMETER",
  globalParameters: "GLOBAL_PARAMETER",
  viewports: "VIEWPORT",
  viewTemplates: "VIEW_TEMPLATE",
  viewTemplateOverrides: "VIEW_TEMPLATE_OVERRIDE",
  dataTables: "DATA_TABLE",
  dataSequences: "DATA_SEQUENCE",
  sectionViews: "SECTION_VIEW",
  presets: "PRESET",
  labels: "LABEL",
  reportableUnitDesignations: "REPORTABLE_UNIT_DESIGNATION",
  effects: "EFFECT",
  datums: "DATUM",
  ruleBasedSelectors: "RULE_BASED_SELECTOR",
  ruleBasedSelectorInstances: "RULE_BASED_SELECTOR_INSTANCE",
  headerAssemblies: "HEADER_ASSEMBLY",
  framingComponents: "FRAMING_COMPONENT",
  cipComponents: "CIP_COMPONENT",
  masonryComponents: "MASONRY_COMPONENT",
  sheathingComponents: "SHEATHING_COMPONENT",
  foundationAssemblies: "FOUNDATION_ASSEMBLY",
  foundationComponents: "FOUNDATION_COMPONENT",
  frameFloorAssemblies: "FRAME_FLOOR_ASSEMBLY",
  slabFloorAssemblies: "SLAB_FLOOR_ASSEMBLY",
  slabComponents: "SLAB_COMPONENT",
  wallPlaneFilters: "WALL_PLANE_FILTER",
  wallPlaneRules: "WALL_PLANE_RULE",
  wallPlaneTrims: "WALL_PLANE_TRIM",
  floorSystems: "FLOOR_SYSTEM",

  // Not entity types
  locked: undefined,
  hidden: undefined,
  entityRoomLayouts: undefined,
  entityGroups: undefined,
  componentMembers: undefined,
  entityRefs: undefined,
  optionChoices: undefined,
  docRefs: undefined,
  facadeSpanStratumAssociations: undefined,
  facadeSweepStratumAssociations: undefined,
  datumSpanAssociations: undefined,
  componentAssociations: undefined,
};
